import { render, staticRenderFns } from "./PublicCharity.vue?vue&type=template&id=0746c3d8&"
import script from "./PublicCharity.vue?vue&type=script&lang=js&"
export * from "./PublicCharity.vue?vue&type=script&lang=js&"
import style0 from "./PublicCharity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports